module.exports = __webpack_public_path__ + "static/dana-85a3fb1588a504d46d816131126c3b35.png";